// - General
import logo from '../static/img/AgriChile.jpg';
import greenHouse from '../static/img/logo-vegsyst.svg';
import openAir from '../static/img/logoAireLibre.svg';
import vegsyst from '../static/img/VegSyst-DSS.svg';

export const ENV = process.env.NODE_ENV || 'development';
export const { TARGET } = process.env;
export const APP_VERSION = '1.13.0';
export const APPLICATION_NAME = 'VegSyst-DSS-Suite';

// export const DATABASE_NAME = 'agrotareo';

// export const CONFIG_BASE_URL = ENV === 'development' && TARGET === 'web'
//   ? LOCAL_DEV_PROXY : CONFIG_PRODUCTION_BASE;

// - Backend API
export const SECONDS_TO_REFRESH_AUTOMATICALLY = 60;
export const SECONDS_BETWEEN_SCANS = 3;

// - Color Theme
export const DEFAULT_PRIMARY_COLOR = '#42526E';
export const DEFAULT_SECONDARY_COLOR = '#009BA6';

// Routes
export const APP_LOGO = logo;
export const VEG_SYST_LOGIN = vegsyst;
export const VEG_SYST = greenHouse;
export const OPEN_AIR = openAir;

// Utils
export const TO_FIXED_DECIMALS_IN_GRAPHICS = false;
export const TO_FIXED_DECIMALS_IN_TABLES = true;
export const NUMBER_OF_DECIMALS = 1;

// Climate constants
export const MEAN_YEAR = 'MEAN_YEAR';
export const REAL_TIME = 'REAL_TIME';

// Device platform
export const DEVICE_PLATFORM = 'web';
